import React from 'react';
import {DateUtil} from '../../util/date-util';
import GIETextField from '../../components/GIETextField/GieTextField';
import {FormValidator} from '../../util/form-validator';
import GIECheckBox from '../../components/GIECheckBox/GieCheckBox';
import userInformations from '../../userInformation/user_informations';
import {Modal} from "@mui/material";
import GIEButton from "../../components/GIEButton/GieButton";
import GieCard from "../../components/GIECard/GieCard";
import CloseIcon from '@material-ui/icons/Close';

export default class PopUpCalendar extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  userNo: string;
  disableBtn: boolean = false;

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      date: '',
      momentInday: 'matin',
      formControls: {
        email: {
          value: '',
          error: false,
          errorMessage: ''
        },
        mobile: {
          value: '',
          error: false,
          errorMessage: ''
        },
        accept: {
          value: false,
          error: false,
          errorMessage: ''
        }
      }
    }
    this.userNo = userInformations.getUserNo();
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({
        open: this.props.open,
        date: this.props.data != null ? DateUtil.convertDateInStringAllInFrench(this.props.data) : ''
      });
      if (this.props.mail != null) {
        let formControls = this.state.formControls;
        formControls.email.value = this.props.mail;
        this.setState({formControls});
      }
    }
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);

    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value,
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    })
    if (this.state.formControls.mobile.value.length === 0) {
      let formControls = this.state.formControls;
      formControls.mobile.error = false;
      this.setState(formControls)
    }
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    Object.keys(formControls).forEach(name => {
      if (this.state.formControls.mobile.value.length === 0 && name === 'mobile') {
        console.log('no mobile phone!');
      } else if (!this.state.formControls.accept.value && name === 'accept') {
        console.log('not accepted !');
      } else {
        const error = this.formValidator.returnError(formControls[name].value, name);
        formControls[name].error = error.error;
        formControls[name].errorMessage = error.errorMessage;
        if (error.error === true) {
          isError = true
        }
      }
    });
    this.setState(formControls)
    return isError;
  }

  closeModal() {
    console.log('close modal')
    this.props.closeModal();
  }

  confirm = (e) => {
    this.disableBtn = true;
    if (this.checkValidForm() === false) {
      this.closeModal();
      this.props.confirmAppointment(this.props.data, this.state.formControls.email.value, this.state.formControls.mobile.value, this.userNo, this.state.formControls.accept.value);
    }
    this.disableBtn = false;
  }

  getDayMoment = () => {
    const date = new Date(this.props.data)
    return date.getHours() > 12 ? 'après-midi' : 'matin'
  }

  checkCGV = (event) => {
    let formControls = this.state.formControls;
    formControls.accept.value = !formControls.accept.value
    if (formControls.accept.value) {
      formControls.accept.error = false;
      formControls.accept.errorMessage = '';
    }
    this.setState({formControls})
  }

  render() {
    return (
      <Modal open={this.state.open} onClose={this.closeModal} aria-labelledby="modal-title">
        <GieCard width="500px" height="auto" className="center-absolute">
          <h4 id="modal-title" className="d-flex justify-content-between align-items-center">
            <span>Modifier votre rendez-vous</span>
            <GIEButton onClick={this.closeModal}>
              <CloseIcon/>
            </GIEButton>
          </h4>

          <div className="my-3">
            Souhaitez-vous reporter votre rendez-vous d’entretien au {this.state.date} {this.getDayMoment()} ?
          </div>
          <div>
            <GIETextField label="Votre email"
                          required
                          type="email"
                          autofocus
                          onChange={this.changeHandler}
                          name="email"
                          value={this.state.formControls.email.value}
                          helperText={this.state.formControls.email.errorMessage}
                          error={this.state.formControls.email.error}/>
            <GIETextField label="Votre numéro de mobile"
                          onChange={this.changeHandler}
                          name="mobile"
                          value={this.state.formControls.mobile.value}
                          helperText={this.state.formControls.mobile.errorMessage}
                          error={this.state.formControls.mobile.error}/>
            <GIECheckBox name="accept"
                         checked={this.state.formControls.accept.value === true}
                         errorText={this.state.formControls.accept.errorMessage}
                         error={this.state.formControls.accept.error}
                         emit={this.checkCGV}
                         label="J’accepte que mes données soient utilisées dans le cadre de la mise à jour de mes coordonnées."/>
          </div>
          <div className="text-center mt-4">
            <GIEButton onClick={this.confirm} classes={{root: 'orange-btn'}} disabled={this.disableBtn}>
              Confirmer
            </GIEButton>
          </div>
        </GieCard>
      </Modal>
    );
  }
}
